function roundNumber(num, dec) {
  return Math.round(num * (10 ** dec)) / (10 ** dec);
}

function formatDate(time) {
  if (!time) {
    return undefined;
  }

  const date = new Date(time);
  const dateMonth = (`0${date.getMonth() + 1}`).slice(-2);
  const dateDay = (`0${date.getDate()}`).slice(-2);
  return `${date.getFullYear()}-${dateMonth}-${dateDay}`;
}

function formatTime(time, timezone = undefined) {
  if (!time) {
    return undefined;
  }
  const date = new Date(time);
  if (timezone === 'Europe/Lisbon') {
    const dateTimeString = date.toLocaleString('pt-PT', { timeZone: 'Europe/Lisbon' });
    const dateString = dateTimeString.slice(0, 10).split('/').reverse().join('-');
    const timeString = dateTimeString.slice(12, 20);
    return `${dateString} ${timeString}`;
  }
  if (timezone === 'Atlantic/Azores') {
    const dateTimeString = date.toLocaleString('pt-PT', { timeZone: 'Atlantic/Azores' });
    const dateString = dateTimeString.slice(0, 10).split('/').reverse().join('-');
    const timeString = dateTimeString.slice(12, 20);
    return `${dateString} ${timeString}`;
  }

  const dateMonth = (`0${date.getMonth() + 1}`).slice(-2);
  const dateDay = (`0${date.getDate()}`).slice(-2);
  return `${date.getFullYear()}-${dateMonth}-${dateDay} ${date.toTimeString().slice(0, 8)}`;
}

function formatPrice(price) {
  return roundNumber(price, 4);
}

function removeNull(obj) {
  if (Array.isArray(obj)) {
    return obj.map((v) => removeNull(v));
  } if (typeof obj === 'object') {
    return Object.entries(obj)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, v]) => v !== null)
      .reduce((acc, [k, v]) => ({ ...acc, [k]: removeNull(v) }),
        {});
  }
  return obj;
}

function formatNumber(num) {
  const numStr = Number(num).toFixed(4);
  const parts = numStr.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  const formattedNum = parts.join('.');
  return formattedNum.replace(/(\.\d*?[1-9])0+|(\.0+)$|(\.$)/, '$1');
}

export {
  roundNumber,
  formatDate,
  formatTime,
  formatPrice,
  removeNull,
  formatNumber,
};
